import {
  Box,
  Container,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { colors } from "theme";

import { OptionsTable } from "./Table";

export const ServiceOptions = () => {
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.only("xs"));

  return (
    <Box
      component="section"
      bgcolor={colors.white}
      pt={{ xs: 3, sm: 4, md: 5, lg: 10 }}
      pb={{ xs: 4, sm: 5, md: 7, lg: 12 }}
      position="relative"
    >
      <Container>
        <Box position="relative">
          <Typography component="h2">
            <Box
              component="span"
              display="block"
              textAlign="center"
              mb={{ xs: 2.25, sm: 4 }}
              fontSize={xs ? 21 : 32}
              lineHeight={xs ? "31px" : "47px"}
              fontWeight={600}
              letterSpacing={0.5}
            >
              Which option is right for you?
            </Box>
          </Typography>
          <OptionsTable />
        </Box>
      </Container>
    </Box>
  );
};
